module.exports = __webpack_public_path__ + "static/media/han-taste-ad4.99883b81.jpg";